var React = require('react');

function Email (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M96,22c0-1.896-0.564-3.648-1.48-5.16L62.968,50.736l31.476,28.56c0.969-1.544,1.553-3.344,1.553-5.292L96,22z","key":0}),React.createElement("path",{"d":"M40.272,52.645c4.112,4.472,11.332,4.483,15.464-0.009l36.068-38.752C90.16,12.712,88.164,12,85.996,12h-76  c-1.94,0-3.744,0.58-5.28,1.544L40.272,52.645z","key":1}),React.createElement("path",{"d":"M60.252,53.66l-1.58,1.691C55.848,58.424,52.057,60.12,48,60.12c-4.056,0-7.848-1.7-10.68-4.776l-1.536-1.688L4.612,82.4  C6.172,83.404,8.012,84,10,84h76c2.12,0,4.084-0.672,5.704-1.805L60.252,53.66z","key":2}),React.createElement("path",{"d":"M1.812,16.292C0.676,17.912,0,19.876,0,22v52c0,2.08,0.64,4.012,1.732,5.611l31.36-28.916L1.812,16.292z","key":3})]);
}

Email.defaultProps = {"version":"1.1","x":"0px","y":"0px","viewBox":"0 0 96 96","enableBackground":"new 0 0 96 96","xmlSpace":"preserve"};

module.exports = Email;

Email.default = Email;
